 /* istanbul ignore file */
import { connect } from 'react-redux';
import IssueListingView from './IssueListingView';
import { getIssueListing } from 'js/app/actions/AppActions';

const mapStateToProps = (state, ownProps) => {
    const { appData } = state.appData;
    
    return {
        appData,
        store: ownProps.store
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getIssueListing: issueList => {
            dispatch( getIssueListing( issueList ) );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueListingView);